import { ref, onMounted, onBeforeUnmount } from '#imports';
import { useScrollListener } from '~/composables/use-scroll-listener';

const mobileBreakpoint = 768;
// @TODO return 44px then pride is over
const mainHeaderHeightOnMobile = 44;

export function useAnimatedHeader(headerElement) {
  const lastScrollTop = ref(0);

  // `window.innerWidth` triggers layout; cache it and refresh on resize
  // instead of reading it inside the scroll handler.
  let isMobile = false;
  function measureViewport() {
    isMobile = window.innerWidth < mobileBreakpoint;
  }

  function onScroll() {
    if (!headerElement.value) return;

    const scrollTopOffset = window.pageYOffset || document.body.scrollTop;
    const isScrollingDown = scrollTopOffset > lastScrollTop.value;

    // eslint-disable-next-line no-param-reassign
    headerElement.value.style.top =
      isScrollingDown && isMobile ? `-${mainHeaderHeightOnMobile}px` : '0';

    lastScrollTop.value = scrollTopOffset <= 0 ? 0 : scrollTopOffset;
  }

  useScrollListener(onScroll, { immediate: false });

  onMounted(() => {
    measureViewport();
    window.addEventListener('resize', measureViewport, { passive: true });
  });

  onBeforeUnmount(() => {
    window.removeEventListener('resize', measureViewport);
  });
}
